import {Component, Input, Output, EventEmitter, ViewChild, OnInit} from '@angular/core';
import {AuthService} from "../../services/auth.service";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {MatLegacySelectChange as MatSelectChange} from "@angular/material/legacy-select";
import {MatTooltipModule} from "@angular/material/tooltip";
import {SaLockControllerDetailComponent} from "./saLockController-detail.component";

@Component({
  selector: 'micro-saLockController-Locks',
  templateUrl: './saLockControllerLocks.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: SaLockControllerLocksComponent
    }
  ]
})
export class SaLockControllerLocksComponent implements OnInit, ControlValueAccessor {

  @Input()
  controllerComponent:SaLockControllerDetailComponent;
  @Input()
  locks:any = [];
  @Input()
  controllerDeviceType: string;

  @Input()
  defaultParamSetsByLockNumber:any = {};
  @Input()
  defaultParamSets:any = {};

  newCategoryIds:any = {
  };

  @Output()
  locksChange:EventEmitter<any> = new EventEmitter<any>();

  onChange = (e) => {};
  onTouched = () => {};
  touched = false;

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(val: string): void {
    this.locks = val;
  }

  change(e) {
    this.onChange(e);
    this.locksChange.emit(e);
  }

  constructor(public authService:AuthService) {
  }

  reload() {
  }

  ngOnInit(): void {
    this.reload();
  }

  getLockDefaultParamSet(lockNumber:any):any {
    return this.defaultParamSetsByLockNumber[lockNumber];
  }

  typeChange(lock) {
    this.controllerComponent.typeChange(lock);
  }

  paramSetCompare(o, s) {
    if (o === undefined && s === undefined) return true;
    if (o === undefined || s === undefined) return false;
    return o.id === s.id;
  }

  selectParamSet(lock, option: MatSelectChange) {
    if (option.value) {
      for (const paramsKey in option.value.params) {
        lock.lockParam[paramsKey] = option.value.params[paramsKey];
      }
      if ((lock.type === 'Servo' || lock.type === 'ServoDelayed' || lock.type === 'ServoEagle') && !lock.lockParam.model)
        lock.lockParam.model = "*";
    }
  }

  calculateServoAngleMax(lock: any) {
    if (this.controllerDeviceType === 'Taulock Micro') {
      return lock.lockParam.angleMin*1 + Math.floor((lock.lockParam.angleMax - lock.lockParam.angleMin) * (140/180));
    } else {
      return lock.lockParam.angleMax;
    }
  }

  addLock() {
    let lastLockNumber = undefined;
    for (const lock of this.locks) {
      if (!lastLockNumber || lock.lockNumber > lastLockNumber) {
        lastLockNumber = lock.lockNumber;
      }
    }
    lastLockNumber = lastLockNumber === undefined ? 0 : lastLockNumber+1;
    this.locks.push({
      lockNumber: lastLockNumber,
      description: undefined,
      openAccessRequestCount: 0,
      type: "",
      lockParam: {},
      createdDate: undefined
    });
  }

  removeLock(lock) {
    this.locks.splice(this.locks.indexOf(lock), 1);
  }

  protected deactivateLock(lock: any) {
    lock.status = 'LOCK_DELETED';

  }
  protected activateLock(lock: any) {
    lock.status = this.controllerComponent.controller.status;
  }

  protected addAccessCategory(lock: any, newCategoryId: string) {
    if (!newCategoryId) return;

    if (!lock.accessCategoryIds) {
      lock.accessCategoryIds = [];
    }
    if (!lock.accessCategoryIds.includes(newCategoryId)) {
      lock.accessCategoryIds.push(newCategoryId);
    }

    setTimeout(() => {
      this.newCategoryIds[lock.lockNumber.toString()] = undefined;
    }, 10);
  }

  protected removeAccessCategory(lock: any, categoryId: any) {
    if (!categoryId) return;

    if (lock.accessCategoryIds) {
      const index = lock.accessCategoryIds.indexOf(categoryId);
      if (index > -1) {
        lock.accessCategoryIds.splice(index, 1);
      }
    }

  }
}
